export enum AdditionalLinkType {
  Video,
  File,
}
export interface AdditionalLink {
  title: string
  url: string
  type: AdditionalLinkType
}
